import styled from 'styled-components';

import { Segment as SegmentLayoutComponent, Text as TextLayoutComponent } from '@playbookux/playbook-web-core';

export const Container = styled(SegmentLayoutComponent)`
    &.ui.segment {
    margin-bottom: 20px;
    padding: 20px;
    width: 100%;
  }
`;

export const Title = styled(TextLayoutComponent.Title)`
  font-size: 16px;
  font-weight: 500;
  display: inline-block;
`;

export const Subtitle = styled(TextLayoutComponent.Title)`
  font-size: 14px;
  float: right;
  display: inline-block;
`;

export const Content = styled.div`
  padding: 20px 0;
`;
